import { Carousel } from './carousel';

export class ProductCarousel extends Carousel {
  /**
   * css selector of carousel container
   * @static
   */
  static selector = '.js-product-carousel';

  /**
   * Checks if container node is present in the dom
   * @function isOnPage
   * @returns {Boolean}
   * @static
   */
  static isOnPage() {
    return document.querySelector(ProductCarousel.selector);
  }

  constructor() {
    super();

    this.carousel = new Map();
    super.init(this, ProductCarousel.selector);
    this.usePointerEvents();
  }

  /**
   * Rebinds product carousel interactions to Pointer Events on hybrid devices.
   * Swiper 8 otherwise registers only touch events when `ontouchstart` is exposed,
   * which prevents mouse and touchpad dragging from working.
   */
  usePointerEvents() {
    if (!window.PointerEvent) {
      return;
    }

    this.carousel.forEach(carousel => {
      if (
        !carousel.initialized ||
        carousel.destroyed ||
        !carousel.support.touch ||
        !carousel.params.scrollbar?.el
      ) {
        return;
      }

      // Remove the touch listeners before changing Swiper's input mode.
      carousel.detachEvents();
      if (carousel.scrollbar) {
        carousel.scrollbar.destroy();
      }

      // Clone support so other Swiper instances keep their original detection.
      carousel.support = {
        ...carousel.support,
        touch: false
      };
      carousel.touchEvents = carousel.touchEventsDesktop;

      carousel.attachEvents();

      if (carousel.scrollbar) {
        carousel.scrollbar.init();
        carousel.scrollbar.updateSize();
        carousel.scrollbar.setTranslate();
      }

      carousel.update();
    });
  }

  /**
   * Generate config depending of the number of the slides in carousel by extending the default config
   * @param {Node} $carousel - Carousel DOM Node
   * @returns {Object} extended config
   */
  generateConfig($carousel) {
    if (super.hasSingleSlide($carousel)) {
      return super.extendConfig({
        pagination: false,
        loop: false,
        autoplay: false,
        observer: true,
        observeParents: true,
      });
    }

    return super.extendConfig({
      slidesPerView: 2.5,
      loop: false,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      scrollbar: {
        el: $carousel.querySelector('.swiper-scrollbar'),
        hide: false,
        draggable: true
      },
      breakpoints: {
        992: {
          slidesPerView: 4.2,
        },
      }
    });
  }
}
